import axios from 'axios';

const log = require("loglevel").getLogger("ProgramService");
log.setLevel("error");

export const loadProgramById = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/program/get/id`, {id})
		.then(async response => {
			const res = response.data.data;
			log.debug("ProgramService -> loadProgramById -> return");
			return res;
		})
		.catch(response => {
			log.debug("ProgramService -> loadProgramById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadPrograms = (selectedFilters, forceReload) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/program/get`, {selectedFilters, forceReload: forceReload === true})
		.then(async response => {
			const res = response.data;
			log.debug("ProgramService -> loadPrograms -> return");
			return res;
		})
		.catch(response => {
			log.debug("ProgramService -> loadPrograms -> error: ");
			log.debug(response);
			return null;
		});
};
